import {
  Button,
  ClickAwayListener,
  Grow,
  MenuItem,
  MenuList,
  Paper,
  Popper,
  Typography,
} from "@mui/material";
import React, { useRef, useState } from "react";

const ActionMenu = (props) => {
  const { icon, menuItems, style = {} } = props;

  const anchorRef = useRef(null);
  const [actionMenuOpen, setActionMenuOpen] = useState(false);

  const handleToggleActionMenu = (event) => {
    event.preventDefault();
    event.stopPropagation();
    setActionMenuOpen((prevOpen) => !prevOpen);
  };

  return (
    <>
      <Button
        ref={anchorRef}
        aria-haspopup="true"
        aria-label="toggle-profile-menu"
        onClick={handleToggleActionMenu}
        aria-controls={actionMenuOpen ? "menu-list-grow" : undefined}
        sx={{
          minWidth: 0,
          borderRadius: "50%",
          padding: "5px",

          ...(actionMenuOpen && {
            backgroundColor: "#F1F6E3",
            color: "#94BA33",
          }),

          "&:hover": {
            backgroundColor: "#F1F6E3",
            color: "#94BA33",
          },
        }}
      >
        <div className="header__profile-button">{icon}</div>
      </Button>
      <Popper
        transition
        role={undefined}
        open={actionMenuOpen}
        placement="bottom-end"
        anchorEl={anchorRef.current}
        style={{
          ...style,
          zIndex: 1300,
        }}
      >
        {({ TransitionProps, placement }) => (
          <Grow
            {...TransitionProps}
            style={{
              transformOrigin:
                placement === "bottom" ? "center top" : "center bottom",
            }}
          >
            <Paper>
              <ClickAwayListener onClickAway={handleToggleActionMenu}>
                <MenuList
                  autoFocusItem={actionMenuOpen}
                  id="menu-list-grow"
                  data-action="insert-new-page-menu"
                  className="user-dropdown"
                >
                  {menuItems?.length &&
                    menuItems.map((item, index) => (
                      <MenuItem
                        key={index}
                        onClick={(event) => {
                          if (item.action) {
                            item.action(event, () => setActionMenuOpen(false));
                          }
                        }}
                        disabled={item.isDisabled}
                      >
                        <Typography textAlign="center">{item.label}</Typography>
                      </MenuItem>
                    ))}
                </MenuList>
              </ClickAwayListener>
            </Paper>
          </Grow>
        )}
      </Popper>
    </>
  );
};

export default ActionMenu;
